import React from 'react';
import './Separator.scss';

export type SeparatorProps = {
    fullWidth?: boolean;
    large?: boolean;
    noTopSpacing?: boolean;
} & React.HTMLAttributes<HTMLDivElement>;

export const Separator: React.FC<SeparatorProps> = ({ className, fullWidth, noTopSpacing, large, ...props }) => {
    return <div className={`separator ${className ?? ''}`} data-full-width={fullWidth} data-no-top-spacing={noTopSpacing} data-large={large} {...props}></div>;
};
